import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { routes } from 'src/routes';
import { verifyUserFx } from 'src/store/user.store';

export const VerificationPage = () => {
	const params = useParams<{ code: string }>();
	const history = useHistory();

	useEffect(() => {
		verifyUserFx({ code: params.code });
		history.push(routes.root.auth.login.path);
	}, []);

	return (
		<></>
	);
};
